var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.153 6.696q.747 0 1.297.558T15 8.571v9.554q0 .759-.55 1.317T13.153 20H1.892Q1.1 20 .55 19.442A1.81 1.81 0 0 1 0 18.125V8.571q0-.759.55-1.317a1.81 1.81 0 0 1 1.342-.558h.923v-1.92q0-1.963 1.386-3.37Q5.586 0 7.522 0q1.935 0 3.3 1.406 1.362 1.407 1.363 3.37v1.92zM7.5 15.268q.77 0 1.32-.558t.55-1.362-.55-1.361a1.79 1.79 0 0 0-1.32-.558q-.77 0-1.32.558t-.55 1.361.55 1.362 1.32.558m2.925-8.572v-1.92q0-1.205-.858-2.075A2.8 2.8 0 0 0 7.5 1.83q-1.21 0-2.045.87a2.9 2.9 0 0 0-.836 2.076v1.92z"
  })));
};
export default SvgLock;